<template>
    <div id="home">
            <div class="flex flex-wrap -mx-3 mb-[12px] md:mb-6">
              <div v-for="(item, index) in overallDetail" :key="index" class="w-full md:w-1/2 xl:w-1/4 px-[12px]">
                <div class="w-full bg-white border text-blue-400 rounded-lg flex items-center p-6 mb-6 xl:mb-0">
                  <i class='bx bx-lg mr-[16px]' :class="item.icon"></i>
                  <div class="text-gray-700">
                    <p class="font-semibold text-2xl">{{ item.quantity }}</p>
                    <p class="text-lg">{{ item.name }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 -mx-3">
              <div class="px-[12px]">
                <div class="w-full bg-white border rounded-lg p-4 flex flex-col gap-0">
                  <p class="text-xl text-center font-semibold mb-4">Tin tức gần đây</p>
                  <div v-for="(news, index) in news" :key="index" :class="index<4 ? 'mb-[16px]' : ''">
                    <div @click="viewNewsDetail(news)" class="w-full bg-gray-100 border-[1px] hover:border-black rounded-lg flex justify-between items-center px-4 py-2 gap-2" v-if="index<5">
                        <div class="flex flex-col">
                            <p class="mb-0 font-semibold cursor-pointer line-clamp-1">{{ news.name }}</p>
                            <p class="mb-0">{{ news.type }}</p>
                        </div>
                        <p class="mb-0 my-auto text-gray-400 font-semibold min-w-[76px] w-max">{{ getDateTime(news.updatedAt) }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="px-[12px] xl:col-span-2 mt-[24px] md:mt-0">
                <div class="w-full bg-white border rounded-lg p-4 mb-8 xl:mb-0">
                  <p class="text-xl text-center font-semibold mb-4">Khoa Kỹ Thuật và Công Nghệ</p>
                  <img class="h-52 md:h-[390px] object-cover" src="@/assets/img/home/homeBanner.jpg" v-viewer>
                </div>
              </div>
            </div>

    </div>
</template>

<script>
import { mapActions } from 'vuex';
import list from "@/mixins/list";
export default {
    name: 'Dashboard',
    mixins: [list],
    data() {
        return {
          overallDetail: [
            {name: 'Chương trình', icon: 'bx-book-bookmark', quantity: '0'},
            {name: 'Tin tức', icon: 'bx-news', quantity: '0'},
            {name: 'Tuyển dụng', icon: 'bx-user-pin', quantity: '0'},
            {name: 'Hợp tác', icon: 'bx-buildings', quantity: '0'},
          ],
          course: [],
          news: [],
          cooperation: [],
          recruitment: [],
        }
    },
    methods: {
      ...mapActions('course', ['GetCourseList']),
      ...mapActions('news', ['GetNewsList']),
      ...mapActions('recruitment', ['GetRecruitmentList']),
      ...mapActions('cooperation', ['GetCooperationList']),
      async getEntry() {
        let courseData = await this.GetCourseList()
        this.overallDetail[0].quantity = courseData.data.length
        this.course = courseData.data
        let newsData = await this.GetNewsList()
        this.overallDetail[1].quantity = newsData.data.data.length
        this.news = newsData.data.data
        let recruitmentData = await this.GetRecruitmentList()
        this.overallDetail[2].quantity = recruitmentData.data.data.length
        this.recruitment = recruitmentData.data.data
        let cooperationData = await this.GetCooperationList()
        this.overallDetail[3].quantity = cooperationData.data.length
        this.cooperation = cooperationData.data
      },
      viewNewsDetail(entry) {
        this.$router.push({
          name: "admin.news.detail",
          params: { id: entry._id },
        });
      },
    },
}
</script>